export const closeHintsOnClick = (activeHint, setActiveHint) => {
  const handleClick = () => {
    if (activeHint) setActiveHint('');
  };

  window.addEventListener('click', handleClick);
  window.addEventListener('touchstart', handleClick);

  return () => {
    window.removeEventListener('click', handleClick);
    window.removeEventListener('touchstart', handleClick);
  };
}